import { Box, Tooltip, Typography } from "@material-ui/core";
import { get, isEmpty } from "lodash";
import UserProfileWidget from "../../../widgets/UserProfileWidget";
import { useStyles } from "../styles";

const CheckinCoach = colProps => {
  const classes = useStyles();
  return (
    <td>
      {!isEmpty(get(colProps, "dataItem.checkinCoach", {})) ? (
        <Tooltip title={get(colProps, "dataItem.checkinCoach.firstName", "")}>
          <Box
            display="flex"
            className={classes.coacheeList}
            alignItems="center"
          >
            <UserProfileWidget
              firstName={get(colProps, "dataItem.checkinCoach.firstName", "")}
              lastName={get(colProps, "dataItem.checkinCoach.lastName", "")}
              url={get(colProps, "dataItem.checkinCoach.profileImage.fileName", "")}
            />
            <Box width="60%" textAlign="left">
              <Typography variant="body2" noWrap="true" className="font-13">
                {`${get(colProps, "dataItem.checkinCoach.firstName", "")} ${get(colProps, "dataItem.checkinCoach.lastName", "")}`}
              </Typography>
            </Box>
          </Box>
        </Tooltip>
      ) : (
        "-"
      )}
    </td>
  );
};

export default CheckinCoach;
